/* ------------------------------------------------------------------------ */
/*		File: generic.d.ts                                                   */
/*		Description: Component interface definition                         */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

export enum colorType {
    YELLOW = "yellow",
    RED = "red",
    BLUE = "blue"
}

export enum statusType {
    SUCCESS = "check.svg",
    FAIL = "xmark.svg",
}

export interface ISpinner {
    type: string, 
    isLoading?: boolean, 
}